export type VERSION = 'mania1' | 'mania2'

export enum AdCommonEvents {
  Visit = 'visit',
  RegNotFinished = 'reg-not-finished',
  RegFinished = 'reg-finished',
  LandingPageView = 'landing-page-view',
}
